var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOneOnOneWhiteTransparent({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.999,
    height: 32.001,
    viewBox: "0 0 41.999 32.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "one-on-one",
    transform: "translate(-3 -10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M-12122-8762h-34a4.006,4.006,0,0,1-4-4v-24a4.006,4.006,0,0,1,4-4h34a4,4,0,0,1,4,4v24A4,4,0,0,1-12122-8762Zm-7-18.9h0v8.9h3v-12h-.3l-5.7,1.8v2.1l3-.8Zm-11,5.9v3h3v-3Zm-9-5.9h0v8.9h3v-12h-.3l-5.7,1.8v2.1l3-.8Zm9-1.1v3h3v-3Z",
    transform: "translate(12163 8804)",
    fill: "#fff",
    opacity: 0.701
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneOnOneWhiteTransparent);
export default __webpack_public_path__ + "static/media/one-on-one_white-transparent.906b34ea9a8db3793b7435fd2284ebc0.svg";
export { ForwardRef as ReactComponent };